<div class="tt-add-resource-tags">
  <div class="tt-add-resource-tags_search">
    <tt-form-field>
      <input
        placeholder="{{ 'ResourceTag.SearchPlaceholder' | transloco }}"
        ttInput
        [ngModel]="searchTerm()"
        [noBorder]="true"
        (ngModelChange)="searchTerm.set($event)" />
    </tt-form-field>
  </div>

  @if (tags()?.length) {
    <p class="tt-add-resource-tags_description">{{ 'ResourceTag.AvailableTags' | transloco }}</p>
  }

  <ul class="tt-add-resource-tags_list">
    @if (loading()) {
      <div class="tt-add-resource-tags_list-loading">
        <tt-spinner [size]="'24'" />
      </div>
    } @else {
      @for (tag of filteredTags(); track tag.id) {
        <li class="tt-add-resource-tags_item" [attr.data-testid]="'tt-add-resource-tags_item-' + tag.label">
          <button class="tt-add-resource-tags_item-button" (click)="toggleTag($event, tag)">
            <tt-resource-tag-chip [customBackgroundColor]="tag.backgroundColor" [customColor]="tag.color" [label]="tag.label">
              {{ tag.label }}
            </tt-resource-tag-chip>
            <common-checkbox [checked]="tag.selected" (click)="toggleTag($event, tag)" />
          </button>
        </li>
      }
    }
    @if (showAddOption()) {
      <li class="tt-add-resource-tags_item--add" data-testid="tt-add-resource-tags_item--add">
        <div class="tt-add-resource-tags_item--add-color">
          <div class="tt-add-resource-tags_item--add-color-selector">
            <tt-dot class="tt-add-resource-tags_item--add-color-selector-dot" [customColor]="selectedColor()" [size]="'large'" />
            <input
              class="tt-add-resource-tags_item--add-color-selector-input"
              data-testid="tt-add-resource-tags_color-input"
              type="color"
              [value]="selectedColor()"
              (input)="selectedColor.set($any($event.target).value)" />
          </div>
          <div class="tt-add-resource-tags_item--add-color-selector">
            <tt-dot class="tt-add-resource-tags_item--add-color-selector-dot" [customColor]="selectedBackgroundColor()" [size]="'large'" />
            <input
              class="tt-add-resource-tags_item--add-color-selector-input"
              data-testid="tt-add-resource-tags_background-color-input"
              type="color"
              [value]="selectedBackgroundColor()"
              (input)="selectedBackgroundColor.set($any($event.target).value)" />
          </div>
          <tt-resource-tag-chip [customBackgroundColor]="selectedBackgroundColor()" [customColor]="selectedColor()" [label]="searchTerm()">
            {{ searchTerm() }}
          </tt-resource-tag-chip>
        </div>
        <button
          class="tt-add-resource-tags_item--add-button"
          data-testid="tt-add-resource-tags_item--add-button"
          ttButton
          [size]="'xSmall'"
          [variant]="'transparent'"
          (click)="makeAddNewTagCall()">
          {{ 'ResourceTag.Add' | transloco }}
        </button>
      </li>
    }
  </ul>
</div>
